/**
 * Created by ws7 on 17/6/14.
 */

import Vue from 'vue';
import suid from '../../services/suid';

export default Vue.extend({
    name: 'KsDatalist',
    props: {
        data: {
            type: Array,
            required: true,
            default: () => []
        },
        value: {
            type: String,
            required: false,
            default: null
        },
        isTagKey: {
            type: Boolean,
            default: false
        },
        isTagValue: {
            type: Boolean,
            default: false
        },
        validName: {
            type: String,
            default: 'datalist'
        },
        filterModel: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            uuid: '',
            filterString: '',
            open: false,
            key: false,
            check: false,
            optionsFiltered: []
        };
    },
    computed: {

    },
    methods: {
        getOptionsFiltered() {
            if (this.key) {
                return this.data
            }
            if(this.check) {
                this.open = false;
                return
            }
            if (this.filterString) {
                let resultList = _.filter(this.data, (v) => v.Key.indexOf(this.filterString) != -1);
                resultList.length == 0 ? this.open = false : this.open = true;
                if(resultList.length == 0){
                    this.$emit('dataChange', resultList);
                }
                return resultList
            } else {
                return this.data;
            }
        },
        clickHandler(e, key) {
            this.check = false
            this.data.length > 0 ? this.open = true : this.open = false;
            if (key == 'all') {
                this.key = true
            } else {
                this.key = false
            }
            this.optionsFiltered = this.getOptionsFiltered();
            this.$nextTick(() => {
                $(document).trigger('ks-datalist-click', [this.uuid]);
                this.$forceUpdate();
            });
        },
        selectData(item) {
            this.check = true;
            this.$emit('input', item.Key);
            this.filterString = item.Key;
            this.open = false;
            this.$emit('dataChange', item.Key);
        },
        closeMe(e, data) {
            if (data === this.uuid) {
                return;
            }
            this.open = false;
        },
    },
    destroy() {
        var me = this;
        $(document).off('click', me.closeMe).off('ks-datalist-click', me.closeMe);
    },
    mounted() {
        var me = this;
        this.cloneData = _.clone(this.data);
        this.$nextTick(() => {
            me.uuid = suid('ks-datalist');
            console.log(me.uuid)
            $(document).on('click', me.closeMe).on('ks-datalist-click', me.closeMe)
        });
    },
    created() {
        // this.cloneData = _.clone(this.data);
    },
    watch: {
        filterString(val, old) {
            this.$emit('input', val);
        },
        filterModel(val, old) {
            this.filterString = val;
        }
    }
});
